<template>
  <div class="zhanwei4"></div>
  <div class="topBar">
    <el-button size="large" type="primary" @click="addAd">添加广告</el-button>
  </div>
  <div class="switchBar">
    <el-table :data="tableData" style="width: 100%">
      <el-table-column label="id" prop="id" />
      <el-table-column label="主标题" prop="firstTitle" />
      <el-table-column label="副标题" prop="secondTitle" />
      <el-table-column label="外链" prop="outlink" />
      <el-table-column label="图片" align="center">
        <template #default="{ row }">
          <el-image :src="row.advImg" :fit="contain" />
        </template> </el-table-column
      >>
      <el-table-column label="创建时间" prop="createTime" align="center" />
      <el-table-column align="center">
        <template #default="scope">
          <el-button
            type="success"
            size="default"
            @click="handleEdit(scope.row)"
            >编辑</el-button
          >

          <el-button
            type="danger"
            size="default"
            @click="deleteAd(scope.row.id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      v-model="dialogVisible"
      width="500"
      draggable
      :show-close="false"
    >
      <el-form :model="form" label-width="auto" style="max-width: 600px">
        <el-form-item label="排名">
          <el-input
            v-model="form.adRank"
            autosize
            type="number"
            placeholder="Please input"
          />
        </el-form-item>

        <el-form-item :label="$t('edit.cover.gameCover')">
          <el-upload
            class="avatar-uploader"
            :action="UpdateApi"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
            :limit="1"
            :file-list="fileList"
            :disabled="allowUpload"
          >
            <el-image
              :src="form.advImg"
              v-if="form.advImg"
              class="avatar"
              alt=""
              :fit="'contain'"
            >
              <template #error>
                <div class="image-slot">
                  <el-icon><icon-picture /></el-icon>
                </div>
              </template>
            </el-image>
            <el-button v-else type="primary">{{ "添加图片" }}</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item v-if="allowUpload">
          <el-button type="warning" @click="clearImage">{{
            $t("settings.clearImg")
          }}</el-button>
        </el-form-item>

        <el-form-item label="主标题">
          <el-input v-model="form.firstTitle" type="text" />
        </el-form-item>
        <el-form-item label="副标题">
          <el-input v-model="form.secondTitle" type="text" />
        </el-form-item>
        <el-form-item label="外链">
          <el-input v-model="form.outlink" type="text" />
        </el-form-item>
      </el-form>

      <template #footer>
        <div class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitReply">
            {{ isAdd ? "增加" : "修改" }}
          </el-button>
        </div>
      </template>
    </el-dialog>
    <div class="pagination">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>

  <div class="zhanwei3"></div>
</template>

<script lang="ts">
import { defineComponent, markRaw } from "vue";
import {
  Right,
  FolderChecked,
  Plus,
  More,
  ArrowLeft,
  AlarmClock,
  QuestionFilled,
  Location,
  Picture as IconPicture,
  Delete,
} from "@element-plus/icons-vue";
import {
  ElMessage,
  ElMessageBox,
  ElNotification,
  TabsPaneContext,
} from "element-plus";
import { Form } from "@/views/view";
export default defineComponent({
  name: "App",
  data(): any {
    return {
      currentPage: 1,
      total: 1,
      dialogImageUrl: "",
      dialogVisible: false,
      activeName: "first",
      tableData: [],
      status: 0,
      isAdd: false,
      centerDialogVisible: false,
      form: {
        adRank: 1,
        advImg: "",
        createTime: "",
        firstTitle: "",
        id: "",
        outlink: "",
        secondTitle: "",
      },
    };
  },
  components: {
    Right,
    FolderChecked,
    Plus,
    More,
    ArrowLeft,
    AlarmClock,
    QuestionFilled,
    Location,
    IconPicture,
  },
  computed: {
    doubledCounter(): number {
      return this.counter * 2;
    },
    allowUpload() {
      return this.form.advImg !== "";
    },
    UpdateApi() {
      return process.env.VUE_APP_Update_API;
    },
  },
  mounted() {},
  created() {
    this.fetchAdvertises(this.currentPage, this.status);
  },
  methods: {
    fetchAdvertises(pageNum: number) {
      const pageSize = 10;
      this.dialogVisible = false;
      this.$store
        .dispatch("user/getAdList", { pageNum, pageSize })
        .then((res: any) => {
          console.log(res);
          this.tableData = res.records;
          this.total = res.total;
        })
        .catch((err: any) => {
          ElMessage({
            message: err,
            type: "warning",
          });
        });
    },
    handleCurrentChange(val: number) {
      this.fetchAdvertises(val, this.status);
    },
    handleEdit(row: Form) {
      this.dialogVisible = true;
      this.isAdd = false;
      this.form = row;
    },
    handleClick(tab: TabsPaneContext) {
      this.status = tab.paneName === "first" ? 0 : 2;
      this.fetchAdvertises(1, this.status);
    },
    quash(index: number, data: any) {
      this.updateGame(index, data.id);
    },
    updateGame(status: number, userId: string) {
      this.$store
        .dispatch("game/UpdateUserStatus", { status: status, userId: userId })
        .then((res: any) => {
          this.handleCurrentChange(this.currentPage);
        })
        .catch(() => {});
    },
    handleAvatarSuccess(response: any) {
      this.form.advImg = response.data.returnFileUrl;
    },
    beforeAvatarUpload(file: File) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPNG) {
        ElNotification.warning({
          message: "请上传png/jpg",
          offset: 100,
          duration: 3000,
        });
        return false;
      }
      if (!isLt2M) {
        ElNotification.warning({
          message: "图片必须小于5m",
          offset: 100,
          duration: 3000,
        });
        return false;
      }

      // Display uploaded avatar
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.form.advImg = reader.result as string;
      };

      return true;
    },
    clearImage() {
      this.form.advImg = "";
      this.fileList = [];
    },
    submitReply() {
      const { id, ...restForm } = this.form;

      if (this.isAdd) {
        this.$store
          .dispatch("user/addAdertise", restForm)
          .then((res: any) => {
            this.fetchAdvertises();
          })
          .catch((err: any) => {
            ElMessage({
              message: err || "添加失败",
              type: "error",
            });
          });
      } else {
        this.$store
          .dispatch("user/editAdvertise", this.form)
          .then((res: any) => {
            this.fetchAdvertises();
          })
          .catch((err: any) => {
            ElMessage({
              message: err || "修改成功",
              type: "error",
            });
          });
      }
    },
    addAd() {
      this.dialogVisible = true;
      this.isAdd = true;
    },
    deleteAd(id: string) {
      ElMessageBox.confirm("是否删除广告", "Warning", {
        type: "warning",
        icon: markRaw(Delete),
        confirmButtonText: this.$t("List.confirm"),
        cancelButtonText: this.$t("List.channel"),
        draggable: true,
        overflow: true,
      })
        .then(() => {
          this.$store
            .dispatch("user/deleteAd", { id: id })
            .then((res: any) => {
              if (res == 1) {
                this.fetchAdvertises();
              }
            })
            .catch(() => {});
        })
        .catch(() => {});
    },
  },
});
</script>

<style lang="less" scoped>
.switchBar {
  width: 100%;
  height: auto;
}

.topBar {
  width: 100%;
  height: 100px;
  display: flex;
  justify-content: flex-start;
  padding-left: 20px;
  align-items: center;
}

.pagination {
  margin-top: 20px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
